"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcessPaymentAllocationMethod = exports.OverpaymentAllocationDetails = void 0;
var OverpaymentAllocationDetails;
(function (OverpaymentAllocationDetails) {
    OverpaymentAllocationDetails["PURCHASE_FIRST"] = "PURCHASE_FIRST";
    OverpaymentAllocationDetails["EQUAL_PAYMENTS"] = "EQUAL_PAYMENTS";
})(OverpaymentAllocationDetails || (exports.OverpaymentAllocationDetails = OverpaymentAllocationDetails = {}));
var ExcessPaymentAllocationMethod;
(function (ExcessPaymentAllocationMethod) {
    ExcessPaymentAllocationMethod["HIGHEST_APR_FIRST"] = "HIGHEST_APR_FIRST";
    ExcessPaymentAllocationMethod["CREDIT_CARD_BALANCE_FIRST"] = "CREDIT_CARD_BALANCE_FIRST";
})(ExcessPaymentAllocationMethod || (exports.ExcessPaymentAllocationMethod = ExcessPaymentAllocationMethod = {}));
